import { FileTypes } from '../../enums/fileTypes';

export const vectorLayerType = (layerType?: string) => layerType && ['WMS', FileTypes.RASTER, 'raster'].includes(layerType);
